module.exports = __webpack_public_path__ + "img/linare-logo-blue.c2c28819.png";